/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Tue May 07 2024
 **/

import { Icon, Row } from "@/frameworks/designStuff/components";
import { Maybe } from "@/frameworks/libraries/components";
import { usePersistUser } from "@/frameworks/core/persistence";
import { _T } from "@rfice/language";
import { UserItem } from "@/frameworks/core/components";

import * as S from "../emotion";

export default function UserToInvite({
	userID,
	selected,
	disabled,
	onSelectUser,
	me
}: {
	userID: string;
	selected: boolean;
	disabled: boolean;
	onSelectUser: (user: WebServices.User.UserInfo) => void;
	me?: boolean;
}) {
	const user = usePersistUser(userID);

	if (!user || user.blockedByMe || user.blockedMe) return;
	return (
		<S.LI key={user.userId}>
			<button
				className="user-button"
				data-email={user.username}
				css={{ width: "100%" }}
				onClick={() => onSelectUser(user)}
				disabled={disabled}
			>
				<UserItem id={user.userId} me={me}>
					<Maybe test={selected}>
						<Row
							css={{
								width: "100%"
							}}
							horizonAlign="right"
						>
							<S.CheckIconWrap>
								<Icon name="Check24" size="24" />
							</S.CheckIconWrap>
						</Row>
					</Maybe>
					<Maybe test={disabled}>
						<S.MemberTypo typoSize="Button2">{_T("· 멤버")}</S.MemberTypo>
					</Maybe>
				</UserItem>
			</button>
		</S.LI>
	);
}
